const M = {
    id:        null,
    char_id:   '',
    name:      '',
    name_slug: '',
    type: 'SERVICE',
    codes: [],
    doctorSpecialities_id: [],
    parent_id: null,
    parents: [],
    children: [],
    name_info: {
        singular: {
            nominative:    '',
            genitive:      '',
            dative:        '',
            accusative:    '',
            ablative:      '',
            prepositional: '',
        },
        plural:   {
            nominative:   '',
            genitive:     '',
            dative:       '',
            accusative:   '',
            ablative:     '',
            prepositional: '',
        },
        short:    '',
    },
    tags: [],
}

export function GET_DEFAULT_M () { return {M: JSON.parse(JSON.stringify(M))};}
export function  initialState() { return JSON.parse(JSON.stringify(
    {
        M: M,
        types: {
            SERVICE: 'Услуга',
            DIAGNOSTIC: 'Диагностика'
        },
        urlAvailable: true,
        parentsAutocompleteArr: [
            {parent_id:0, parents: [{'name': 'НЕТ (корневой элемент)'}]}
        ],
    }
));}
